var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('navigation',[_c('router-view',{style:(_vm.height),attrs:{"id":"page"}})],1),_vm._v(" "),(_vm.CommentSetShow.show)?_c('commentReplySet'):_vm._e(),_vm._v(" "),(_vm.LaunchWeappShow)?_c('launchWeapp'):_vm._e(),_vm._v(" "),_c('div',{attrs:{"id":"CB_B_398"}}),_vm._v(" "),_c('div',{attrs:{"id":"CB_B_red"}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d56d0850","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = null
// module chunks = 